import { IconX } from 'featherico';
import Button from '../../../../components/Button';
import { FormSelect } from '../../../../components/Form/FormInputs';
import { FormItem } from '../../../../components/Form/FormItem';
import r from '../../../../services/Replacement';
import { CustomMapping } from './customMapping';
import { CustomFieldConfig } from './types';

const USER_PROPERTIES = {
    firstName: 'First Name',
    lastName: 'Last Name',
    description: 'Description',
    gender: 'Gender',
    role: 'Title',
    group: r('team.big'),
    department: 'Department',
    location: 'Location',
    hiringDate: 'Hiring Date',
    terminationDate: 'Termination Date',
    preferredName: 'Preferred Name',
    secondaryReviewerLogin: `${r('secondaryManager.big')} (email)`,
};

interface Props {
    caption: string;
    sourceLabel: string;
    targetLabel: string;
    config: CustomFieldConfig;
    field: string;
    onDelete: () => void;
    nrFields: number;
    customMappingState: CustomMapping;
}

export default function CustomFieldMapping({
    caption,
    sourceLabel,
    targetLabel,
    config,
    field,
    onDelete,
    nrFields,
}: Props) {
    return (
        <section>
            <div className="admin-config-custom-mapping-container">
                {config.supportsFieldId && (
                    <div>
                        <FormItem
                            name={`${field}.customMappingSourceId`}
                            label={`${sourceLabel} Id (Optional)`}
                            inputProps={{
                                type: 'number',
                                placeholder: '123456',
                            }}
                            showError={() => true}
                        />
                    </div>
                )}
                <div>
                    <FormItem
                        name={`${field}.customMappingSource`}
                        label={sourceLabel}
                        inputProps={{
                            placeholder: 'e.g. firstName',
                        }}
                        showError={() => true}
                    />
                </div>
                <div>
                    <FormItem
                        name={`${field}.customMappingTarget`}
                        type="select"
                        label={targetLabel}
                        inputComponent={FormSelect}
                        showError={() => true}
                        inputProps={{
                            options: [null, ...Object.keys(USER_PROPERTIES)],
                            optionToText: (property: keyof typeof USER_PROPERTIES) => USER_PROPERTIES[property] || '-',
                        }}
                    />
                </div>
                <div style={{ flex: 0, minWidth: 17, alignSelf: 'top', marginTop: '35px' }}>
                    {nrFields > 1 && (
                        <Button kind="PLAIN" type="button" onClick={onDelete}>
                            <IconX />
                        </Button>
                    )}
                </div>
            </div>
            <aside>{caption}</aside>
        </section>
    );
}
